import client from "./client";

const InstructorService = {};

InstructorService.get = function (data) {
  return client.get(`/instructor`, data);
};
InstructorService.create = function (data) {
  return client.post(`/instructor`, data);
};

InstructorService.update = function (id, data) {
  return client.put(`/instructor/${id}`, data);
};

InstructorService.delete = function (id) {
  return client.del(`/instructor/${id}`);
};

export default InstructorService;
